<template>
  <layout name="Settings">
    <div class="settings-wrapper">
      <VSettingsSidebarLayoutHeading
        title="Billing"
        :buttons="buttons"
        extraClass="settings account-billing-heading"
      />
      <WithLoader :isLoading="isLoading" classType="primary">
        <div class="billing-history__wrapper">
          <h3>Billing information</h3>
          <div class="billing-info">
            <span class="billing-company">{{ getBillingContactFullName }}</span>
            <span
              class="billing-edit"
              @click="navigate('/account/organization/billing-settings')"
              >Edit</span
            >
            <span class="billing-address">{{ billingAddressToString }}</span>
          </div>

          <h3 class="history">Billing History</h3>

          <div class="billing-history-table__wrapper">
            <BillingHistoryTable />
          </div>

          <BillingInvoicesPagination></BillingInvoicesPagination>
        </div>
      </WithLoader>
    </div>
  </layout>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import Layout from "@/layouts/Layout";
import WithLoader from "@/components/WithLoader";

// components
import BillingAddPaymentMethodForm from "@/components/BillingAddPaymentMethodForm";
import VSettingsSidebarLayoutHeading from "@/components/VSettingsSidebarLayoutHeading";
import BillingHistoryTable from "@/components/BillingHistoryTable";
import BillingSelect from "@/components/BillingSelect";
import BillingInvoicesPagination from "@/components/BillingInvoicesPagination";

// mixins
import withFormUtils from "@/mixins/withFormUtils";
import withToasted from "@/mixins/withToasted";
import withNavigate from "@/mixins/withNavigate";
import plaidLogo from "@/assets/images/plaid-logo.svg";
import reloadIcon from "@/assets/images/reload.svg";

export default Vue.component("AccountOrganizationBilling", {
  metaInfo: {
    title: "Settings - Billing"
  },

  components: {
    Layout,
    WithLoader,
    VSettingsSidebarLayoutHeading,
    BillingHistoryTable,
    BillingAddPaymentMethodForm,
    BillingSelect,
    BillingInvoicesPagination
  },

  mixins: [withFormUtils, withToasted, withNavigate],

  data() {
    return {
      addNewPaymentOpened: false,
      name: "paymentInfo",

      buttons: [
        // {
        //   key: "add-payment",
        //   label: "Add Payment Method",
        //   size: "sm",
        //   onClickHandler: this._addPrimaryBtnHandler,
        //   extraClass: "payment-add-primary-button",
        //   disabled: this.isLoading
        // }
      ],

      plaidLogo,
      reloadIcon
    };
  },

  methods: {
    _addPrimaryBtnHandler() {
      this.addNewPaymentOpened = true;
    },

    ...mapActions("billing", [
      "fetchSubscriptions",
      "fetchInvoices",
      "fetchPrimaryCard",
      "fetchSubscription",
      "fetchSubscriptionsPlansInfo",
      "fetchBankAccounts",
      "fetchCreditCards",
      "fetchPaymentMethods"
    ])
  },

  computed: {
    _billingAccountOptions() {
      return this.paymentMethods;
    },

    getBillingContactFullName() {
      return (
        this.getAccount.billing_contact_full_name || this.getAccount.company
      );
    },

    billingAddressToString() {
      const {
        billing_address_city,
        billing_address_country,
        billing_address_state
      } = this.getAccount;

      const arr = [
        billing_address_city,
        billing_address_country,
        billing_address_state
      ].filter(item => item);

      return arr.join(", ");
    },

    ...mapGetters("billing", [
      "isLoading",
      "primaryCardId",
      "cardsList",
      "paymentMethods",
      "primaryCard",
      "isPaymentSourceRemoving",
      "invoices"
    ]),
    ...mapGetters("account", ["getAccount"])
  },

  mounted() {
    if (!this.isLoading) {
      // this.fetchPaymentMethods();
      // this.fetchPrimaryCard();
      // this.fetchSubscriptionsPlansInfo();
      // this.fetchSubscription();
      this.fetchInvoices();
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "settings-wrapper";

.#{$ns} {
  height: 100%;
  width: 100%;

  .add-new-card__wrapper,
  .payment-info__wrapper {
    position: relative;
    padding: 20px;
    max-width: 350px;
    box-shadow: 0 0 13px rgba(0, 0, 0, 0.05), 0 0 3px rgba(0, 0, 0, 0.03),
      inset 0 0 5px rgba(255, 255, 255, 0.31);
    background: #fafafa;
    border-radius: 5px;
  }

  .payment-info__wrapper {
    height: 235px;
    overflow: auto;
  }

  h3 {
    margin-bottom: 25px;
    font-family: "Lato-Regular", sans-serif;
    font-style: normal;
    font-size: 16px;
    text-transform: capitalize;
    color: $title-text-color;
  }

  .title {
    font-family: "Lato-Bold", Arial, sans-serif;
    margin-bottom: 30px;
  }

  .divider {
    width: 100%;
    height: 1px;
    background-color: #dfe6f0;
  }

  .payment-info {
    &__add-card-wrapper {
      display: flex;
      justify-content: center;
    }

    &__another-card {
      text-align: center;
      outline: none;
      color: #0e438e;
      cursor: pointer;
      border: none;
      background: transparent;
      font-size: 14px;
      border-radius: 5px;
      padding: 10px 15px;
      width: 170px;
      transition: background-color 0.1s linear;

      &:hover {
        background-color: #dfe6f0;
      }
    }
  }

  .plaid-logo__wrapper {
    text-align: center;
  }

  .plaid__button {
    text-align: center;
    color: #0e438e;
    margin-top: 30px;
    cursor: pointer;
    background: transparent;
    font-size: 14px;
    outline: none;
    border-radius: 5px;
    padding: 10px 15px;
    width: 170px;
    transition: background-color 0.1s linear;
    border: 1px solid #dfe6f0;

    &:hover {
      background-color: #dfe6f0;
    }
  }

  .add-card-wrapper {
    padding: 15px;
  }

  .payment-information {
    display: flex;

    .payment-methods__wrapper,
    .plan-information__wrapper {
      width: 48%;
    }

    .payment-methods__wrapper {
      max-width: 410px;
      margin-right: 40px;
    }

    .account-billing__payment-methods-wrapper {
      position: relative;
      box-shadow: 0 0 13px rgba(0, 0, 0, 0.05), 0 0 3px rgba(0, 0, 0, 0.03),
        inset 0 0 5px rgba(255, 255, 255, 0.31);
      background-color: #fafafa;

      border-radius: 5px;
    }
  }

  .billing-history__wrapper {
    margin-top: 55px;

    .billing-info {
      color: $secondary-text-color;
      margin-bottom: 50px;
      width: fit-content;
      max-width: 350px;
      display: grid;
      grid-template-areas:
        "company edit"
        "address address";
      grid-template-columns: minmax(120px, 1fr) auto;
      grid-gap: 10px 0;
      align-items: center;

      .billing-company {
        grid-area: company;
        font-size: 22px;
        font-family: Lato-Bold, Arial, sans-serif;
        padding-right: 30px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .billing-edit {
        grid-area: edit;
        font-size: 12px;
        color: $primary-grey;
        cursor: pointer;
        &:hover {
          color: $primary-color;
        }
      }
      .billing-address {
        grid-area: address;
        color: $main-text-color;
        font-size: 14px;
        font-family: Lato-Light, Arial, Helvetica Neue, Helvetica, sans-serif;
      }
    }

    .history-loader {
      width: 100%;
      margin-top: 60px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-family: "Lato-Light", Arial, sans-serif;
        margin-left: 30px;
        font-size: 20px;
        color: #c4c4c4;
      }

      &:hover {
        span {
          color: $primary-color;
        }
      }
    }

    & /deep/ .v-pagination-bar__wrapper {
      width: calc(100% - 355px);
      bottom: 0px;
      left: initial;
    }
  }

  .plan-information__wrapper {
    max-width: 410px;
  }

  .ach__wrapper,
  .credit-cards {
    position: relative;
    padding: 30px 30px 40px 30px;
  }

  .credit-cards {
    padding-bottom: 0;
  }

  @media screen and (max-width: 900px) {
    .payment-information {
      flex-direction: column;
      align-items: center;

      .payment-methods__wrapper {
        margin-bottom: 20px;
        margin-right: 0;
      }

      .payment-methods__wrapper,
      .plan-information__wrapper {
        width: 100%;
      }
    }
  }
}
</style>

<style lang="scss">
.sidebar-layout-heading.settings.settings-layout-sidebar-heading {
  color: $primary-text-color;

  margin-bottom: 46px;

  .sidebar-layout-heading__buttons-wrapper {
    display: flex;
    align-items: center;
  }
}

.account-billing-heading .sidebar-layout-heading__title {
  margin-right: 55px;
}

.v-label.label-billing,
.set-primary {
  position: absolute;
  top: 20px;
  right: 0;
}

.v-label.label-billing {
  top: 0;
  right: -20px;
}

.set-primary {
  display: inline-block;
  color: #919191;
  font-size: 14px;
  top: 30px;
  right: 20px;
  cursor: pointer;
}

.v-modal__container.account-billing-ach {
  width: 35%;
  height: 100%;
  max-height: 420px;
  max-width: 450px;
}

.v-modal__container.account-billing-new-card {
  max-width: 500px;
  max-height: 580px;

  .v-modal__body {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
